import { ArrowRightIcon } from '@/assets/icons';
import React from 'react';
import { ReasonCard } from '.';
import Link from 'next/link';
import Image from 'next/image';

const InfoReason = [
  {
    iconType: 'quality',
    title: 'Chất lượng \n đảm bảo',
    desc: 'Trứng được sản xuất và bảo quản đúng quy chuẩn, đảm bảo an toàn vệ sinh thực phẩm cho bếp ăn và nhà hàng.',
  },
  {
    iconType: 'origin',
    title: 'Giấy tờ, chứng nhận đầy đủ',
    desc: 'Nguồn gốc rõ ràng, đầy đủ giấy chứng nhận và hồ sơ pháp lý, minh bạch khi làm việc với đối tác.',
  },
  {
    iconType: 'delivery',
    title: 'Giao hàng trong TP.HCM',
    desc: 'Giao hàng nhanh trong TP.HCM, nhận đơn và bao vận chuyển số lượng lớn theo nhu cầu khách hàng.',
  },
  {
    iconType: 'price',
    title: 'Giá cạnh tranh, ổn định',
    desc: 'Giá cả cạnh tranh so với thị trường, chính sách bình ổn giá hỗ trợ khách hàng hợp tác lâu dài.',
  },
];

const Reason = () => {
  return ( 
    <div className="relative flex py-8 md:py-16 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <Image
          src="/images/anh4.jpg"
          alt="Trứng gia cầm tươi của Trường Thọ Food"
          fill
          priority
          className="object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="flex flex-col w-full gap-8 container relative z-10">
        <div className="flex flex-col items-center text-center gap-4 text-white">
          <p className="uppercase text-[24px] md:text-[32px] font-bold">
            Tại sao nên chọn chúng tôi?
          </p>
          <p className="text-[18px] font-medium max-w-3xl">
            Chúng tôi chú trọng an toàn vệ sinh thực phẩm, giấy tờ minh bạch, giao hàng linh hoạt và giá cả ổn định, phù hợp cho bếp ăn, nhà hàng và xưởng chế biến.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full gap-4 md:gap-5">
          {InfoReason.map((item, index) => (
            <ReasonCard key={index} {...item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reason;
